// if ($(window).width() > 1025) {
// -- -- -- -- -- -- - VARIABLES-- -- -- -- -- -- - //
var ticking = false;
var isFirefox = (/Firefox/i.test(navigator.userAgent));
var isIe = (/MSIE/i.test(navigator.userAgent)) || (/Trident.*rv\:11\./i.test(navigator.userAgent));
var scrollSensitivitySetting = 30; //Increase/decrease this number to change sensitivity to trackpad gestures (up = less sensitive; down = more sensitive) 
var slideDurationSetting = 600; //Amount of time for which slide is "locked"
var currentSlideNumber = 0;
var pageSlide = $(".home-page section, footer, .about-page section, .lien-he-page section, .tuyen-dung-page section, .du-an-page section, .du-an-ct-page section, .tin-tuc-page section");
var totalSlideNumber = pageSlide.length;
// ------------- DETERMINE DELTA/SCROLL DIRECTION ------------- //
function parallaxScroll(evt) {
    let delta = 0
    if (isFirefox) {
        //Set delta for Firefox
        delta = evt.detail * (-120);
    } else if (isIe) {
        //Set delta for IE
        delta = -evt.deltaY;
    } else {
        //Set delta for all other browsers
        delta = evt.wheelDelta;
    }

    if (ticking != true) {
        if (delta <= -scrollSensitivitySetting) {
            //Down scroll
            ticking = true;
            if (currentSlideNumber !== totalSlideNumber - 1) {
                currentSlideNumber++;
                nextItem();
            }
            slideDurationTimeout(slideDurationSetting);
        }
        if (delta >= scrollSensitivitySetting) {
            //Up scroll
            ticking = true;
            if (currentSlideNumber !== 0) {
                currentSlideNumber--;
                previousItem();
            }
            slideDurationTimeout(slideDurationSetting);
        }
    }
}

// ------------- SET TIMEOUT TO TEMPORARILY "LOCK" SLIDES ------------- //
function slideDurationTimeout(slideDuration) {
    setTimeout(function () {
        ticking = false;
    }, slideDuration);
}

// ------------- ADD EVENT LISTENER ------------- //
var mousewheelEvent = isFirefox ? "DOMMouseScroll" : "wheel";
window.addEventListener(mousewheelEvent, _.throttle(parallaxScroll, 60), false);

// ------------- SLIDE MOTION ------------- //
function nextItem() {
    $('section').removeClass('current-page')
    var $previousSlide = pageSlide.eq(currentSlideNumber - 1);
    var $currentSlide = pageSlide.eq(currentSlideNumber);
    $currentSlide.addClass('current-page')
    $previousSlide.removeClass("up-scroll").addClass("down-scroll");
    $('header').addClass('active')
    $('#fake-header-open').addClass('active')
    $('header .search-wrapper').removeClass('active')
    // console.log(currentSlide)
    $('.back-to-top').removeClass('active')
    $('.back-to-home').removeClass('active')
    if ($currentSlide.is(':first-child')) {
        $('.back-to-top').removeClass('active')
        $('.back-to-home').removeClass('active')
    }
    if (currentSlideNumber == 1) {
        $('.home-page #fake-header-open, .about-page #fake-header-open').addClass('last')
        $('.back-to-top').addClass('active')
        $('.back-to-home').addClass('active')
    } else {
        $('.home-page #fake-header-open, .about-page #fake-header-open').removeClass('last')
        $('.back-to-top').addClass('active')
        $('.back-to-home').addClass('active')
    }
    if (currentSlideNumber == 2) {
        $('.about-page #fake-header-open').addClass('last')
        $('.lien-he-page footer').addClass('active')
    } else {
        $('.about-page #fake-header-open').removeClass('last')
        $('.lien-he-page footer').removeClass('active')
    }
    if (currentSlideNumber == 3) {
        $('.du-an-page footer').addClass('active')
        $('.du-an-ct-page footer').addClass('active')
        $('.tuyen-dung-page footer').addClass('active')
        $('.tin-tuc-page footer').addClass('active')
        $('.du-an-ct-page .hong-ha-du-an-ct-1').addClass('animation')
    } else {
        $('.du-an-page footer').removeClass('active')
        $('.du-an-ct-page footer').removeClass('active')
        $('.tuyen-dung-page footer').removeClass('active')
        $('.tin-tuc-page footer').removeClass('active')
        $('.du-an-ct-page .hong-ha-du-an-ct-1').removeClass('animation')
    }
    if (currentSlideNumber == 5) {
        // $('#fake-header-open').addClass('last')
        $('.home-page footer').addClass('active')
        $('.about-page footer').addClass('active')
    } else {
        $('.home-page footer').removeClass('active')
        $('.about-page footer').removeClass('active')
    }
    $('#nav-pagination ul li').removeClass('active')
    $('#nav-pagination ul li:nth-child(' + (currentSlideNumber + 1) + ')').addClass('active')
    // if ($currentSlide.hasClass('home-banner'))
    //     $('header').removeClass('active')
}

function previousItem() {
    $('section').removeClass('current-page')
    $('footer').removeClass('active')
    var $currentSlide = pageSlide.eq(currentSlideNumber);
    $currentSlide.addClass('current-page')
    $('.home-page #fake-header-open, .about-page #fake-header-open').removeClass('last')
    $('.back-to-top').addClass('active')
    $('.back-to-home').addClass('active')
    if ($currentSlide.is(':first-child')) {
        $('header').removeClass('active')
        $('.back-to-top').removeClass('active')
        $('.back-to-home').removeClass('active')
        $('.home-page #fake-header-open, .about-page #fake-header-open, .du-an-ct-page #fake-header-open, .du-an-page #fake-header-open, .lien-he-page #fake-header-open, .tuyen-dung-page #fake-header-open, .tin-tuc-page #fake-header-open').removeClass('active')
    }
    if (currentSlideNumber == 1) {
        $('.home-page #fake-header-open, .about-page #fake-header-open').addClass('last')
    } else {
        $('.home-page #fake-header-open, .about-page #fake-header-open').removeClass('last')
    }
    if (currentSlideNumber == 2) {
        $('.about-page #fake-header-open').addClass('last')
    } else {
        $('.about-page #fake-header-open').removeClass('last')
    }
    if (currentSlideNumber == 3) {
        $('.du-an-ct-page .hong-ha-du-an-ct-1').addClass('animation')
    } else {
        $('.du-an-ct-page .hong-ha-du-an-ct-1').removeClass('animation')
    }

    $currentSlide.removeClass("down-scroll").addClass("up-scroll");
    $('#nav-pagination ul li').removeClass('active')
    $('#nav-pagination ul li:nth-child(' + (currentSlideNumber + 1) + ')').addClass('active')
}

function setBackgroundElement() {
    $('[setBackground]').each(function () {
        var background = $(this).attr('setBackground')
        $(this).css({
            "background-image": "url(" + background + ")",
            "background-size": "cover",
            "background-position": "center center"
        })
    })
    $('[setBackgroundRepeat]').each(function () {
        var background = $(this).attr('setBackgroundRepeat')
        $(this).css({
            "background-image": "url(" + background + ")",
            "background-repeat": "repeat"
        })
    })
}

function srcollHeaderChild() {
    var header = $(".tuyen-dung-ct-page header, .news-detail-page header")
    var fakeHeader = $(".tuyen-dung-ct-page #fake-header-open, .news-detail-page #fake-header-open")
    $('.tin-tuc-page, .tuyen-dung-ct-page, .news-detail-page').scroll(function () {
        var scroll = $('.tin-tuc-page, .tuyen-dung-ct-page, .news-detail-page').scrollTop();
        if (scroll >= 1) {
            header.addClass('active')
            fakeHeader.addClass('active').addClass('last')
        } else {
            header.removeClass("active")
            fakeHeader.removeClass('active')
        }
    });
}

function InitLazyLoad() {
    return new LazyLoad({
        elements_selector: ".lazyload"
    })
}

function EqualHeightElement(el) {
    let height = 0;
    let thisHeight = 0;
    $(el).each(function () {
        thisHeight = $(this).height();
        if (thisHeight > height) {
            height = thisHeight;
        }
    });
    $(el).height(height)
}

function homeBanner() {
    return new Swiper('.home-banner .swiper-container', {
        loop: true,
        speed: 1000,
        pagination: {
            el: '.home-banner .swiper-pagination',
            clickable: true
        },
        effect: 'fade',
        autoplay: {
            delay: 3000
        }
    })
}

function scrollToTop() {
    $('footer .button-wrapper').on('click', function () {
        currentSlideNumber = 0
        $('section').removeClass('down-scroll')
        $('footer').removeClass('active')
        $('header').removeClass('active')
        $('.home-banner').addClass('current-page')
    })
}

function toggleMobileHeader() {
    $('header .toggle-button').on('click', function () {
        $(this).toggleClass('active')
        $('header .mobile-wrapper').toggleClass('active')
    })
}

function mobileMapping() {
    return {
        'ListPage': new MappingListener({
            selector: '.header .main-list-wrapper',
            mobileWrapper: 'header .mobile-wrapper',
            mobileMethod: 'appendTo',
            desktopWrapper: 'header .logo-wrapper',
            desktopMethod: 'insertAfter',
            breakpoint: 1025,
        }).watch(),
        'Social': new MappingListener({
            selector: '.header .social-wrapper',
            mobileWrapper: 'header .mobile-wrapper',
            mobileMethod: 'appendTo',
            desktopWrapper: 'header .main-list-wrapper',
            desktopMethod: 'insertAfter',
            breakpoint: 1025,
        }).watch()
    }
}

function toggleSearchWrapper() {
    $('header .search-button').on('click', function () {
        $('header .search-wrapper').toggleClass('active')
    })
    $('header .search-wrapper .close-button').on('click', function () {
        $('header .search-wrapper').toggleClass('active')
    })
}

function projectImage() {
    $('.home-2 .project-list .item').removeClass('active')
    $('.home-2 .project-list .item').on('mouseover', function () {
        $('.home-2 .project-list .item').removeClass('active')
        $(this).addClass('active')
        let e = $(this).attr('data-image')
        $('.home-2 .image-wrapper img').attr('src', e)
    })
}

function menuImage() {
    $('#fake-header .menu-fake-header ul .item a').on('mouseover', function () {
        $('#fake-header .menu-fake-header ul .item a').removeClass('active')
        $(this).addClass('active')
        let e = $(this).attr('data-bg-menu')
        $('#fake-header').attr('setbackground', e).css({
            "background-image": "url(" + e + ")",
            "background-size": "cover",
            "background-position": "center center"
        })
    })
}

function autoGeneratecreateMobileProjectImage() {
    var x = window.matchMedia("(max-width: 1025px)")
    createMobileProjectImage(x)
    x.addListener(createMobileProjectImage)
}

function createMobileProjectImage(breakpoint) {
    if (breakpoint.matches) {
        $('.home-2 .project-list .item').each(function () {
            let e = $(this).attr('data-image')
            $(this).after("<img class=\"mobile-image-generate\" src=\"" + e + "\"></img>")
        })
    } else {
        $('.home-2 .project-list .mobile-image-generate').remove()
    }
}

function createPagination() {
    $('main').append("<div id=\"nav-pagination\"><ul></ul></div>")
    for (let i = 0; i < totalSlideNumber; i++) {
        if (i == 0) {
            $('#nav-pagination ul').append('<li class=\'active\' data-section=\'' + (i + 1) + '\'>' + (i + 1) + '</li>')
        } else {
            $('#nav-pagination ul').append('<li data-section=\'' + (i + 1) + '\'>' + (i + 1) + '</li>')
        }
    }
    $('#nav-pagination ul li').on('click', function () {
        $('#nav-pagination ul li').removeClass('active')
        $(this).addClass('active')
        let e = $(this).attr('data-section') - 1
        $('.page-wrap section').removeClass('down-scroll up-scroll')
        if (e < currentSlideNumber) {
            currentSlideNumber = e
            $('.page-wrap section:nth-child(' + (currentSlideNumber + 1) + ')').addClass('up-scroll current-page')
            $('.page-wrap section').removeClass('down-scroll')
            for (let i = currentSlideNumber; i < totalSlideNumber; i++) {
                $('.page-wrap section:nth-child(' + (currentSlideNumber + 1) + ')').addClass('up-scroll')
            }
        } else {
            currentSlideNumber = e
            $('.page-wrap section').removeClass('current-page')
            $('.page-wrap section:nth-child(' + (currentSlideNumber + 1) + ')').addClass('current-page')
            for (let i = 0; i < currentSlideNumber; i++) {
                $('.page-wrap section:nth-child(' + (i + 1) + ')').addClass('down-scroll')
            }
        }
        if ((currentSlideNumber + 1) == totalSlideNumber) {
            $('footer').addClass('active')
        } else {
            $('footer').removeClass('active')
        }
        if (currentSlideNumber != 0) {
            $('header').addClass('active')
            $('#fake-header-open').addClass('active')
        } else {
            $('header').removeClass('active')
            $('#fake-header-open').removeClass('active')
        }
        if (currentSlideNumber == 5) {
            $('#fake-header-open').addClass('last')
        } else {
            $('#fake-header-open').removeClass('last')
        }
    })
}

function fakeHeader() {
    let e = $('header .main-list-wrapper').html()
    $('#fake-header .menu-fake-header').append(e)
    $('#fake-header-open').on('click', function () {
        $('#fake-header').addClass('active')
    })
    $('#fake-header .close-button').on('click', function () {
        $('#fake-header').removeClass('active')
    })
}

function fakeLogo() {
    let e = $('header .logo-wrapper').html()
    $('#fake-header .logo-fake-header').append(e)
    $('#fake-header-open').on('click', function () {
        $('#fake-header').addClass('active')
    })
    $('#fake-header .close-button').on('click', function () {
        $('#fake-header').removeClass('active')
    })
}
function fakeLanguage() {
    let e = $('header .language-wrapper').html()
    $('#fake-header .menu-fake-header').append(e)
    $('#fake-header-open').on('click', function () {
        $('#fake-header').addClass('active')
    })
    $('#fake-header .close-button').on('click', function () {
        $('#fake-header').removeClass('active')
    })
}

function createSwiperElementMobile() {
    let e = "<div class=\'swiper-container\'><div class=\'swiper-wrapper\'></div></div>"
    $('.home-3 .container').append(e)
    $('.home-3 .news-list .item').each(function () {
        let i = '<div class=\'swiper-slide\'>' + this.outerHTML + '</div>'
        $('.home-3 .swiper-wrapper').append(i)
    })
    return new Swiper('.home-3 .swiper-container', {
        speed: 1000,
        autoplay: {
            delay: 4000
        },
        spaceBetween: 30
    })
}

function bannerSlideBig() {
    return new Swiper('.hongha-banner-big .swiper-container', {
        loop: true,
        speed: 1000,
    });
}

function bannerSlideChild() {
    return new Swiper('.hongha-banner-child .swiper-container', {
        loop: true,
        speed: 1000,
    });
}

function tinTucTab() {
    $('.hong-ha-tin-tuc-2 .main-nav .item').on('click', function () {
        $('.hong-ha-tin-tuc-2 .main-nav .item').removeClass('active')
        $(this).addClass('active')
        let indexTab = $(this).attr('data-tab')
        $('.hong-ha-tin-tuc-2 .content-item').removeClass('active')
        $('.hong-ha-tin-tuc-2 .content-item[data-content=' + indexTab + ']').addClass('active')
    })
}

function shareNews() {
    $("#shareCustomLogo").jsSocials({
        showLabel: false,
        showCount: false,
        shares: [{
            share: "facebook",
            logo: "fab fa-facebook-f"
        }, {
            share: "twitter",
            logo: "fab fa-twitter",
        }]
    });
}

function duAnCTSLide() {
    var swiper = new Swiper('.hong-ha-du-an-ct-1 .swiper-container', {
        spaceBetween: 30,
        pagination: {
            el: '.hong-ha-du-an-ct-1 .swiper-pagination',
            clickable: true,
        },
    });
}

function changeTitleAbout3() {
    var text1 = $('.hong-ha-about-3 .item .hong-ha-title .copy-text-1').text()
    var text2 = $('.hong-ha-about-3 .item .hong-ha-title .copy-text-2').text()
    var roles = [text1, text2]
    var counter = 0
    var $role = $('.hong-ha-about-3 .item .hong-ha-title h2')
    setInterval(function () {
        $role.text(roles[counter++]);
        if (counter >= roles.length) {
            counter = 0;
        }
    }, 3000)
}

function numberAutoRun() {
    if ($('.hong-ha-about-1').find('current-page')) {
        $('.hong-ha-about-1 .main-number .item .number span').on('click', function () {
            console.log(1)
        })
        $('.hong-ha-about-1 .main-number .item .number span').each(function () {
            var $this = $(this);
            jQuery({
                Counter: 0
            }).animate({
                Counter: $this.text()
            }, {
                duration: 4500,
                easing: 'swing',
                step: function () {
                    $this.text(Math.ceil(this.Counter));
                    // $this.text(Math.ceil(this.Counter).toLocaleString('de-DE'));
                    var numberAfterRun = $(this).attr('data-number')
                    $this.text(numberAfterRun)
                },
            });
        });
    } else {
        $('.hong-ha-about-1 .main-number .item .number span').on('click', function () {
            console.log(2)
        })
        $('.hong-ha-about-1 .main-number .item .number span').each(function () {
            var $this = $(this);
            var numberAfterRun = $(this).attr('data-number')
            $this.text(numberAfterRun)
        });
    }
}
// function addClassFancyboxShowThumb(){
//     $('.hong-ha-du-an-ct-2 .item').on('click', function(){
//         $('.fancybox-container').addClass('fancybox-show-thumbs')
//     })

// }
function checkWidth(){
    // console.log($(window).outerWidth())
    if ($(".about-page").length && $(window).outerWidth() >= 250) {
        $('.hong-ha-about-2 .right-wrap').addClass('item-w250')
        $('.hong-ha-about-3 .item-hidden').addClass('item-w250')
    }else{
        $('.hong-ha-about-2 .right-wrap').removeClass('item-w250')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w250')
    }
    if ($(".about-page").length && $(window).outerWidth() >= 1024) {
        $('.hong-ha-about-2 .right-wrap').removeClass('item-w250')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w250')
        $('.hong-ha-about-2 .right-wrap').addClass('item-w1024')
        $('.hong-ha-about-3 .item-hidden').addClass('item-w1024')
    }else{
        $('.hong-ha-about-2 .right-wrap').removeClass('item-w1024')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1024')
    }
    if ($(".about-page").length && $(window).outerWidth() >= 1280) {
        $('.hong-ha-about-2 .right-wrap').removeClass('item-w250')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w250')
        $('.hong-ha-about-2 .right-wrap').removeClass('item-w1024')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1024')
        $('.hong-ha-about-2 .right-wrap').addClass('item-w1280')
        $('.hong-ha-about-3 .item-hidden').addClass('item-w1280')
    }else{
        $('.hong-ha-about-2 .right-wrap').removeClass('item-w1280')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1280')
    }
    if ($(window).outerWidth() == 1366 && $(window).outerHeight() == 1024) {
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1024')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1440')
        $('.hong-ha-about-3 .item-hidden').addClass('item-w1366')
    }else{
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1440')
        $('.hong-ha-about-3 .item-hidden').removeClass('tem-w1366')
    }
    if ($(".about-page").length && $(window).outerWidth() >= 1440) {
        $('.hong-ha-about-2 .right-wrap').removeClass('item-w1024')
        $('.hong-ha-about-2 .right-wrap').addClass('item-w1440')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1024')
        $('.hong-ha-about-3 .item-hidden').removeClass('tem-w1366')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1280')
        $('.hong-ha-about-3 .item-hidden').addClass('item-w1440')
    }else{
        $('.hong-ha-about-2 .right-wrap').addClass('item-w1440')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1440')
    }
    if ($(".about-page").length && $(window).outerWidth() == 1920) {
        $('.hong-ha-about-2 .right-wrap').removeClass('item-w1024')
        $('.hong-ha-about-2 .right-wrap').addClass('item-w1440')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1024')
        $('.hong-ha-about-3 .item-hidden').removeClass('tem-w1366')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1280')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1440')
        $('.hong-ha-about-3 .item-hidden').addClass('item-w1920')
    }else{
        $('.hong-ha-about-2 .right-wrap').addClass('item-w1440')
        $('.hong-ha-about-3 .item-hidden').removeClass('item-w1920')
    }
}
function backToTop() {
    if ($(window).outerWidth() > 1025) {
        $('.back-to-top').on('click', function () {
            $('header').removeClass('active')
            $('footer').removeClass('current-page active')
            $('#fake-header-open').removeClass('active')
            $('.back-to-home').removeClass('active')
            let e = $(this).attr('data-section') - 1
            $('.page-wrap section').removeClass('down-scroll up-scroll')
            if (e < currentSlideNumber) {
                currentSlideNumber = e
                $('.page-wrap section:nth-child(' + (currentSlideNumber + 1) + ')').addClass('up-scroll current-page')
                $('.page-wrap section').removeClass('down-scroll')
                $(`#nav-pagination ul li`).removeClass('active')
                $(`#nav-pagination ul li[data-section=${currentSlideNumber + 1}]`).addClass('active')
                for (let i = currentSlideNumber; i < totalSlideNumber; i++) {
                    $('.page-wrap section:nth-child(' + (currentSlideNumber + 1) + ')').addClass('up-scroll')
                    $(`#nav-pagination ul li`).removeClass('active')
                    $(`#nav-pagination ul li[data-section=${currentSlideNumber + 1}]`).addClass('active')
                }
            } else {
                currentSlideNumber = e
                $('.page-wrap section').removeClass('current-page')
                $('.page-wrap section:nth-child(' + (currentSlideNumber + 1) + ')').addClass('current-page')
                $(`#nav-pagination ul li`).removeClass('active')
                $(`#nav-pagination ul li[data-section=${currentSlideNumber + 1}]`).addClass('active')
                for (let i = 0; i < currentSlideNumber; i++) {
                    $('.page-wrap section:nth-child(' + (i + 1) + ')').addClass('down-scroll')
                }
            }
            $('.back-to-top').removeClass('active')
        })
    } else {
        $(window).scroll(function (event) {
            var scroll = $(window).scrollTop()
            if (scroll > 5) {
                $('header').addClass('active')
                $('#fake-header-open').addClass('active')
            } else {
                $('header').removeClass('active')
                $('#fake-header-open').removeClass('active')
            }
            if (scroll > 500) {
                $('.back-to-top').addClass('active')
                $('.back-to-home').addClass('active')
            } else {
                $('.back-to-top').removeClass('active')
                $('.back-to-home').removeClass('active')
            }
        })
        $('.back-to-top').on('click', function () {
            $("html,body").animate({
                scrollTop: 0
            }, 1300)
        })
    }
    $('.news-detail-page').scroll(function (event) {
        var scroll = $('.news-detail-page').scrollTop()
        // console.log(scroll)
        if (scroll > 5) {
            $('header').addClass('active')
            $('#fake-header-open').addClass('active')
        } else {
            $('header').removeClass('active')
            $('#fake-header-open').removeClass('active')
        }
        if (scroll > 500) {
            $('.back-to-top').addClass('active')
            $('.back-to-home').addClass('active')
        } else {
            $('.back-to-top').removeClass('active')
            $('.back-to-home').removeClass('active')
        }
    })
    $('.back-to-top').on('click', function () {
        $("html,body").animate({
            scrollTop: 0
        }, 1300)
    })
}
$(document).ready(function () {
    InitLazyLoad()
    homeBanner()
    srcollHeaderChild()
    setBackgroundElement()
    scrollToTop()
    toggleMobileHeader()
    mobileMapping()
    toggleSearchWrapper()

    // hover change image
    projectImage()
    menuImage()

    autoGeneratecreateMobileProjectImage()
    createPagination()
    // fakeLogo()
    fakeHeader()
    fakeLanguage()
    createSwiperElementMobile()
    numberAutoRun()
    setTimeout(() => {
        $('section:first-child').addClass('current-page')
    }, 100);
    setInterval(function () {
        menuImage()
        // backToTop()
    }, 100)
    // checkWidth()
    checkWidth()
    bannerSlideBig()
    bannerSlideChild()
    tinTucTab()
    shareNews()
    duAnCTSLide()
    changeTitleAbout3()
    EqualHeightElement('.hong-ha-about-3 .item')
    backToTop()
    $('[data-fancybox]').fancybox({
        fullScreen: true,
        protect: true,
        // buttons: [
        //     'zoom',
        //     'thumbs',
        //     'close',
        //     'autoplay'
        // ],
        thumbs: {
            autoStart: true,
            margin: [44, 0, 22, 0],
            axis: 'x'
        },
        zoom: {
            maxRatio: 5,
        },
    });
})